// pulled from random internet lists
// feel free to add more later
// if time allows, we could make an actual table and reference it in the experience section,
// but not worth the time investment
const commonJobTitles = [
    "CEO",
    "Chief Architect",
    "Chief Digital Officer",
    "Chief Innovation Officer",
    "CIO",
    "CTO",
    "Director of Engineering",
    "Engineering Fellow",
    "Engineering Lead",
    "Engineering Manager",
    "Engineering Project Manager",
    "Intern Software Developer",
    "Junior Software Developer",
    "Principal Software Engineer",
    'Program Manager',
    "Senior Software Developer",
    "Senior Software Engineer",
    "Software Architect",
    "Software Developer",
    "Software Engineer",
    "Team Lead",
    "Technical Lead",
    "VP of Engineering",
];

export { commonJobTitles };